import { Component, ViewChild, Input } from '@angular/core'

import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid'
import { jqxMenuComponent } from 'jqwidgets-ng/jqxmenu'
import { ClipboardService } from 'ngx-clipboard'
@Component({
    selector: 'copyto-clipboard',
    template: `<jqxMenu #myMenu (onItemclick)="onItemClick()" [mode]="'popup'" [autoOpenPopup]="false">
        <ul>
            <li>Copy</li>
        </ul>
    </jqxMenu>`
})
export class CopytoClipboardComponent {
    @ViewChild('myMenu', { static: true }) myMenu: jqxMenuComponent
    clipboardContent: string
    private _myGrid: jqxGridComponent
    @Input()
    set grid(gridObj: jqxGridComponent) {
        this._myGrid = gridObj
    }
    @Input() set event(eventObj: any) {
        let selectedArray = this._myGrid != undefined ? this._myGrid.getselectedcells() : undefined
        if (eventObj && selectedArray && selectedArray.length > 0) {
            this.addContextMenuEventListener()
            this._myGrid.selectrow(eventObj.args.rowindex)
            let scrollTop = window.scrollY
            let scrollLeft = window.scrollX
            this.myMenu.open(
                parseInt(eventObj.args.originalEvent.clientX) + 5 + scrollLeft,
                parseInt(eventObj.args.originalEvent.clientY) + 5 + scrollTop
            )
        }
    }
    constructor(private clipboardService: ClipboardService) {}
    onItemClick(): void {
        let selectedCells = this._myGrid.getselectedcells()
        this.clipboardContent = ''
        let startIndex = 0,
            endIndex = 0
        if (selectedCells != undefined && selectedCells.length > 0) {
            startIndex = selectedCells[0].rowindex || 0
            endIndex = selectedCells[selectedCells.length - 1].rowindex || 0
            for (let i = startIndex; i <= endIndex; i++) {
                let selectedRow = selectedCells.filter((x) => x.rowindex == i)
                let copiedRowContent = ''
                this.clipboardContent = this.clipboardContent == '' ? this.clipboardContent : this.clipboardContent + '\r\n'
                selectedRow.forEach((element) => {
                    let cellValue = this._myGrid.getcellvalue(i, element.datafield || '')
                    copiedRowContent = copiedRowContent == '' ? cellValue : copiedRowContent + '	' + cellValue
                })
                this.clipboardContent = this.clipboardContent + copiedRowContent
            }
        }
        this.clipboardService.copyFromContent(this.clipboardContent)
    }
    addContextMenuEventListener() {
        Array.from(document.querySelectorAll('jqxGrid')).forEach(function (item) {
            item.addEventListener('contextmenu', (event) => event.preventDefault())
        })
    }
}
